import { safeReturnPath } from './safeReturnPath';

// The LoginPage route's path. Kept here rather than resolved from the route table so the session
// timer, which runs outside any screen, can build the address without the route configuration.
const LOGIN_PATH = '/login';

/**
 * The login page address for a user whose session has expired, carrying the page they are on
 * (path, query and hash) so sign-in can return them there.
 *
 * The page travels in the address, not in router state, because the timer reloads the whole page
 * after signing the user out and router state does not survive a reload.
 *
 * @param {{ pathname?: string, search?: string, hash?: string }} [location]
 * @returns {string}
 */
export const sessionExpiredLoginUrl = location => {
  const { pathname = '', search = '', hash = '' } = location || {};
  const base = `${LOGIN_PATH}?sessionExpired=true`;
  return pathname ? `${base}&from=${encodeURIComponent(`${pathname}${search}${hash}`)}` : base;
};

/**
 * The return page carried in a login page's query, or null when there is none or it is not a page
 * on this site.
 *
 * Anyone can write a link to the login page, so the value is untrusted. It is checked decoded once
 * more than it arrives (so `/%2F…` is refused too), but returned as it arrived, so an encoded query
 * in the page's own address stays encoded.
 *
 * @param {string} [search]
 * @returns {string|null}
 */
export const returnPathFromLoginSearch = search => {
  const from = new URLSearchParams(search || '').get('from');
  if (!from) return null;
  return safeReturnPath(from, null) === null ? null : from;
};
